import React from "react";
import { Box, Typography } from "@mui/material";
import FirstLineContainer from "components/common/FirstLineContainer";

const TopPanelComponent = ({ page, version }) => {
  return (
    <FirstLineContainer>
      <Box display="flex" alignItems="center" width="100%">
        <Typography variant="h6" sx={{ textAlign: "left", flex: 1 }}>
          <Box component="span" fontWeight="fontWeightBold">
            {page}
          </Box>
        </Typography>
        <Typography variant="h6" sx={{ textAlign: "right", flex: 0, mr: 2 }}>
          <Box component="span" fontWeight="fontWeightBold">
            {version}
          </Box>
        </Typography>
      </Box>
      <Box minHeight={24} />
    </FirstLineContainer>
  );
};

export default TopPanelComponent;
